<template>
  <CandleClash />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CandleClash from "./components/CandleClash.vue";

export default defineComponent({
  name: "App",
  components: {
    CandleClash,
  },
});
</script>

<style>
html,
body {
  margin: 0;
  background-color: #131722;
}
#app {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Trebuchet MS",
    Roboto, Ubuntu, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #d1d4dc;
}
/* Monospace reserved for numeric/price readouts, TradingView-style. */
.cc-mono {
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-variant-numeric: tabular-nums;
}
</style>
